(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ask-a-question-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ask-faq-open]');
    if (openButton) {
      const dialog = openButton.closest('[data-ask-faq]')?.querySelector('dialog');
      if (dialog) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-ask-faq-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('dialog.ask-faq__dialog')) event.target.close();
  });
  } catch(e) { console.error(e); }
})();

})();
